(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.eventOccurenceOngoing = _exports.eventOccurenceLimited = _exports.eventEntityKey = _exports.eventContextVirtual = _exports.eventContextOnSite = _exports.eventContextHybrid = _exports.eventContextCompanies = _exports.defaultBraindateSlug = _exports.defaultBraindateSingular = _exports.defaultBraindatePlural = void 0;

  /**
   * Entity key used by the event schema
   * @type {string}
   */
  var eventEntityKey = "events";

  /**
   * Default string for the event slug
   * @type {string}
   */
  _exports.eventEntityKey = eventEntityKey;
  var defaultBraindateSlug = "braindates";

  /**
   * Default string for the singular of "braindate"
   * @type {string}
   */
  _exports.defaultBraindateSlug = defaultBraindateSlug;
  var defaultBraindateSingular = "braindate";

  /**
   * Default string for the plural of "braindate"
   * @type {string}
   */
  _exports.defaultBraindateSingular = defaultBraindateSingular;
  var defaultBraindatePlural = "braindates";

  /**
   * String for event context : Hybrid
   * @type {string}
   */
  _exports.defaultBraindatePlural = defaultBraindatePlural;
  var eventContextHybrid = "hybrid";

  /**
   * String for event context : OnSite
   * @type {string}
   */
  _exports.eventContextHybrid = eventContextHybrid;
  var eventContextOnSite = "live";

  /**
   * String for event context : Companies
   * @type {string}
   */
  _exports.eventContextOnSite = eventContextOnSite;
  var eventContextCompanies = "company";

  /**
   * String for event context : Virtual
   * @type {string}
   */
  _exports.eventContextCompanies = eventContextCompanies;
  var eventContextVirtual = "virtual";

  /**
   * String for event occurrence : Limited
   * @type {string}
   */
  _exports.eventContextVirtual = eventContextVirtual;
  var eventOccurenceLimited = "limited";

  /**
   * String for event occurrence : Ongoing
   * @type {string}
   */
  _exports.eventOccurenceLimited = eventOccurenceLimited;
  var eventOccurenceOngoing = "ongoing";
  _exports.eventOccurenceOngoing = eventOccurenceOngoing;
});